import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EquipmentListQuery } from '../../../shared/interfaces/equipment.interfaces';
import { DashEquipmentResponse } from '../../../shared/interfaces/dashboard.interfaces';

const basePath = '/dashboard';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  constructor(private http: HttpClient) { }

  // Get connection counter for dealer
  getConnCounter(dealerId?: number | string): Observable<{ [key: string]: number }> {
    let params = new HttpParams();
    if (dealerId) {
      params = params.set('dealerId', dealerId.toString());
    }
    return this.http.get<{ [key: string]: number }>(`${basePath}/conn_counter`, { params });
  }

  getChildren() {
    return this.http.get<any>(`${basePath}/children`);
  }

  // Gets a list of equipments for the current dealer
  getEquipments(query?: EquipmentListQuery, currentPage?: number): Observable<DashEquipmentResponse> {
    const params = new HttpParams()
      .set('rows', (query?.rows ?? 10).toString())
      .set('first', ((currentPage ?? 0) * (query?.rows ?? 10)).toString())
      .set('sort_order', (query?.sort_order ?? 1).toString())
      .set('sort_field', query?.sort_field ?? 'id')
      .set('filters', JSON.stringify(query?.filters ?? {}));
    return this.http.get<DashEquipmentResponse>(`${basePath}/get_equipments`, { params });
  }
}